module.exports = __webpack_public_path__ + "static/media/g-icon-add_square.63c9f2a7.svg";